module.exports = __webpack_public_path__ + "img/视频封面25.f8457312.png";